var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-recent-posts"},[_c('loader',{attrs:{"loading":_vm.loading}}),_vm._v(" "),_vm._l((_vm.posts),function(post){return (!_vm.loading)?_c('post-teaser',{key:post.id,attrs:{"post":post}}):_vm._e()}),_vm._v(" "),(!_vm.loading && !_vm.posts)?_c('p',[_vm._v(_vm._s(_vm.user.name)+" hasn't made any posts yet.")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }